// extracted by mini-css-extract-plugin
export var header = "br1-R";
export var headerBg = "br1-T";
export var headerBgFixedDown = "br1-Y";
export var headerBgFixedUp = "br1-U";
export var headerContent = "br1-V";
export var headerContentBox = "br1-X";
export var headerContentBoxLogo = "br1-Z";
export var headerContentMain = "br1-_";
export var headerContentNav = "br1--";
export var headerContentNavActive = "br1-0";
export var headerContentNavActiveItem = "br1-1";
export var navHover = "br1-W";
export var navHoverBottom = "br1-9";
export var navHoverContent = "br1-2";
export var navHoverContentMain = "br1-3";
export var navHoverContentSlide = "br1-4";
export var navHoverContentSlideBox = "br1-7";
export var navHoverContentSlideBoxItem = "br1-8";
export var navHoverContentSlideTitle = "br1-5";
export var navHoverContentSlideTitle2 = "br1-6";
export var navHoverDisable = "br1-aa";
export var underline = "br1-S";